/*
 * @Autor: fengqi
 * @Date: 2019-10-11 14:46:15
 * @LastEditors: fengqi
 * @LastEditTime: 2019-10-14 15:00:26
 */
/* eslint-disable */
// 时间倒计时
const countDown = (t) => {
  var time = t > 0 ? t / 1000 : 0
  var day = parseInt(time / (3600 * 24))
  var hour = parseInt(time / 3600 - day * 24)
  var minute = parseInt((time - hour * 60 * 60 - day * 24 * 60 * 60) / 60)
  var str = minute + '分'
  if (day > 0) {
    return day + '天' + hour + '小时' + str
  } else {
    if (hour > 0) {
      return hour + '小时' + str
    } else {
      return str
    }
  }
}

// 截取路由参数 参数格式在#之后
const getDatas = (url = window.location) => {
  var args = {}
  var argsStr = url.search; //获取URL参数字符串

  if (argsStr.length > 0) {
    argsStr = argsStr.substring(1);
    var nameValueArr = argsStr.split("&"); //多参数
    for (var i = 0; i < nameValueArr.length; i++) {
      var pos = nameValueArr[i].indexOf("=")
      if (pos == -1) continue //如果没有找到就跳过
      var argName = nameValueArr[i].substring(0, pos) //提取name
      var argVal = nameValueArr[i].substring(pos + 1) //提取value
      args[argName] = argVal
    }
    return args
  }
}
const utils = {
  countDown,
  getDatas
}

export default utils
